import { ColorPalette, ErrorState } from '@shared/components';

export default function CertificateNavigatorError() {
  return (
    <ErrorState
      title='ไม่สามารถแสดงหนังสือรับรองผลการทดสอบได้'
      description='เนื่องจากลิงก์ไม่ถูกต้องหรือหนังสือรับรองหมดอายุ กรุณาตรวจสอบและลองใหม่อีกครั้ง'
      slotProps={{
        icon: {
          color: ColorPalette.ERROR,
        },
      }}
      fullscreen
    />
  );
}
